"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gradient = exports["default"] = void 0;
var _color = require("./color");
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var gradient = {
  moonlightGradient: _color.themecolor.moonlightGradient,
  greyBlueGradient: _color.themecolor.greyToBlueGradient,
  berryGradient: _color.themecolor.berryGradient
};
exports.gradient = gradient;
var _default = gradient;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(gradient, "gradient", "/Users/crs/WebstormProjects/michelangelo/src/Components/styles/gradient.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/styles/gradient.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();